<template>
  <div class="container">
    <div class="avatar">
      <img :src="user.avatar">
    </div>
    <div class="info">
      <div class="item">
        <div class="label">用户名</div>
        <div class="content">
          <div class="value">{{ user.name }}</div>
          <i class="arrow iconfont icon-onetabarrow-right"></i>
        </div>
      </div>
      <div class="item">
        <div class="label">电子邮件</div>
        <div class="content">
          <div class="value">{{ user.email }}</div>
          <i class="arrow iconfont icon-onetabarrow-right"></i>
        </div>
      </div>
      <div class="item">
        <div class="label">密码</div>
        <div class="content">
          <i class="arrow iconfont icon-onetabarrow-right"></i>
        </div>
      </div>
    </div>
    <RaButton class="logout-btn" status="tertiary" @click="logout">退出登录</RaButton>
  </div>
</template>

<script setup>
import { user } from '../store/user';
import { RaButton } from '@rafter/pc';
import { defineEmits } from 'vue';

const emits = defineEmits(['logout']);

const logout = () => {
  localStorage.removeItem('onetab_token');
  localStorage.removeItem('onetab_userInfo');
  localStorage.removeItem('category');

  window['_paq'].push(['trackEvent', '用户', '退出登录', user.email, 1]);
  user.token = "";
  emits('logout');
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.avatar {
  margin-top: 24px;

  img {
    width: 56px;
    height: 56px;
    border-radius: 28px;
  }
}

.info {
  margin: 24px 0;
  width: 320px;
  font-size: 13px;

  .item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 48px;
    box-sizing: border-box;
    border-bottom: 1px solid var(--border-default);

    .label {
      @include font_color('text-on-surface-tertiary');
    }

    .content {
      display: flex;
      align-items: center;

      .value {
        @include font_color('text-on-surface-primary');
      }

      .arrow {
        margin-left: 8px;
        font-size: 10px;
        @include font_color('text-on-surface-tertiary');
        font-weight: 600; 
      }
    }
  }
}

.logout-btn {
  width: 320px;
  @include font_color('text-on-surface-primary');
  --button-brand-tertiary-background: var(--background-default);
  --button-brand-tertiary-background-hover: var(--background-on-background);
}
</style>